export default "__VITE_ASSET__DwAm7Ogx__"